export default "if (a) {\n  b=c;\n}\n"